module.exports = __webpack_public_path__ + "static/media/LandingPage.8ca94e3f.png";